// Mock data baseado no código original
export const mockData = {
  supplier: {
    id: 1,
    name: "Fornecedor Premium Ltda",
    trade_name: "Premium Suprimentos",
    legal_name: "Fornecedor Premium Ltda",
    specialty: "Material de Escritório e Informática"
  },
  client: {
    id: 1,
    name: "Cliente Exemplo S/A"
  },
  quotation: {
    id: "COT-2025-0001",
    expirationDate: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000), // 2 days from now
  },
  unitsOfMeasure: [
    { id: 1, name: "Litros", abbreviation: "L" },
    { id: 2, name: "Quilos", abbreviation: "kg" },
    { id: 3, name: "Quilogramas", abbreviation: "kg" },
    { id: 4, name: "Gramas", abbreviation: "g" },
    { id: 5, name: "Metros", abbreviation: "m" },
    { id: 6, name: "Centímetros", abbreviation: "cm" },
    { id: 7, name: "Milímetros", abbreviation: "mm" },
    { id: 8, name: "Metros²", abbreviation: "m²" },
    { id: 9, name: "Metros³", abbreviation: "m³" },
    { id: 10, name: "Peças", abbreviation: "pç" },
    { id: 11, name: "Unidades", abbreviation: "un" },
    { id: 12, name: "Pares", abbreviation: "par" },
    { id: 13, name: "Dúzias", abbreviation: "dz" },
    { id: 14, name: "Centenas", abbreviation: "cento" },
    { id: 15, name: "Milhares", abbreviation: "mil" },
    { id: 16, name: "Caixas", abbreviation: "cx" },
    { id: 17, name: "Fardos", abbreviation: "fardo" },
    { id: 18, name: "Pacotes", abbreviation: "pct" },
    { id: 19, name: "Sacos", abbreviation: "saco" },
    { id: 20, name: "Toneladas", abbreviation: "t" },
    { id: 21, name: "Mililitros", abbreviation: "ml" },
    { id: 22, name: "Galões", abbreviation: "gal" },
    { id: 23, name: "Barris", abbreviation: "barril" }
  ],
  items: [
    { id: 1, name: "Papel A4 75g" },
    { id: 2, name: "Tinta Preta HP" },
    { id: 3, name: "Cabo Ethernet Cat6" },
    { id: 4, name: "Limpador Multiuso" },
    { id: 5, name: "Açúcar Cristal" },
    { id: 6, name: "Café Premium" },
    { id: 7, name: "Papel Higiênico" },
    { id: 8, name: "Monitor LED 24 polegadas" },
    { id: 9, name: "Mouse Wireless" },
    { id: 10, name: "Teclado Mecânico" }
  ]
}

// Função para buscar unidade de medida por ID
export const getUnitById = (unitId) => {
  return mockData.unitsOfMeasure.find(unit => unit.id === parseInt(unitId))
}

// Função para buscar categoria por ID  
export const getCategoryById = (categoryId) => {
  return mockData.categories.find(category => category.id === parseInt(categoryId))
}

// Função para filtrar itens por categoria
export const getItemsByCategory = (categoryId) => {
  return mockData.items.filter(item => item.categoryId === parseInt(categoryId))
}

// Função para simular busca de itens
export const searchItems = (searchTerm) => {
  if (!searchTerm) return mockData.items
  
  return mockData.items.filter(item => 
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase())
  )
}